import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private-routes/influencer/')({
  beforeLoad: () => {
    throw redirect({
      to: '/influencers'
    });
  }
});
